import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Radio } from '@platform/base';
import CompMeta from '../../meta/LowCodeComponents/Radio';
/**
 * @class NCRadio
 * @column 1
 * @compType 1
 * @canAppend false
 * @path LowCodeComponents.NCRadio
 * @label 单选
 *
 */
class NCRadio extends Component {
    constructor(props) {
        super(props);
    }
    static propTypes = {
        /**
        * @title 区域编码
        * @description 组件标识
        */
        moduleId: PropTypes.string.isRequired,
        /**
         * @title className
         * @description 样式
         */
        className: PropTypes.string,
        /**
         * @title 自动化Id
         * @description 自动化Id
         */
        fieldid: PropTypes.string,

    }
    static getCompMeta = () => {
        return CompMeta;
    }
    render() {
        return (
            <Radio {...this.props} >{this.props.children}</Radio>
        )
    }
}

export default NCRadio;
